import WhiteCheck from "@/assets/icons/WhiteCheck.svg";

export type CheckBoxProps = {
  disable?: boolean;
  required?: boolean;
  value?: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
};
export const CustomCheckbox = ({
  disable,
  required,
  value,
  checked,
  onChange,
  name,
}: CheckBoxProps) => {
  return (
    <div className="inline-flex items-center">
      <label
        className="relative flex items-center  rounded-full cursor-pointer"
        htmlFor="checkbox"
      >
        <input
          disabled={disable}
          required={required}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          type="checkbox"
          className="before:content[''] peer relative h-4 w-4 cursor-pointer appearance-none rounded-[4px] border border-[#D0D5DD] transition-all before:absolute before:top-2/4 before:left-2/4 before:block  before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#17457D] checked:bg-[#17457D] checked:before:bg-[#17457D] hover:before:opacity-10"
          id="checkbox"
        />

        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
          <WhiteCheck />
        </span>
      </label>
    </div>
  );
};
